import React from 'react';
import { timeline } from '../mock';

export default function Timeline() {
  return (
    <section className="px-5 sm:px-8 mt-24">
      <div className="mx-auto max-w-[1400px]">
        <div className="pb-10 max-w-2xl">
          <div className="inline-flex items-center gap-2 text-[11px] tracking-[0.22em] uppercase text-neutral-500">
            <span className="tag-dot" /> What to expect
          </div>
          <h2 className="font-grotesk mt-3 text-4xl sm:text-5xl tracking-[-0.02em] font-medium">
            Your 60-day <span className="font-display italic text-teal">reset</span>.
          </h2>
        </div>

        <div className="grid md:grid-cols-3 gap-4">
          {timeline.map((t, i) => (
            <div key={i} className="relative rounded-2xl bg-white dark:bg-neutral-950 border border-black/5 dark:border-white/5 p-6 hover-lift">
              <div className="flex items-center justify-between">
                <span className="font-mono text-[11px] uppercase tracking-widest text-teal">{t.day}</span>
                <span className="h-6 w-6 rounded-full bg-[color:var(--cv-teal)] text-white text-[11px] font-bold inline-flex items-center justify-center">{i+1}</span>
              </div>
              <h4 className="font-grotesk mt-4 text-2xl font-medium tracking-tight">{t.title}</h4>
              <p className="mt-2 text-[14px] text-neutral-500 leading-relaxed">{t.desc}</p>
              <div className="mt-6 h-1 bg-neutral-100 dark:bg-neutral-900 rounded-full overflow-hidden">
                <div className="h-full bg-[color:var(--cv-teal)] rounded-full" style={{ width: `${(i+1) * 33.33}%` }} />
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
